// extracted by mini-css-extract-plugin
export var button = "_ey-4";
export var hasDarkBackground = "_ey-7";
export var hasLightBackground = "_ey-6";
export var iconWrapper = "_ey-0";
export var large = "_ey-2";
export var medium = "_ey-1";
export var small = "_ey-5";
export var xsmall = "_ey-3";